import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeDegatValues } from 'src/api/models';

@Component({
  selector: 'app-degats-type',
  templateUrl: './degats-type.component.html',
  styleUrls: ['./degats-type.component.css']
})
export class DegatsTypeComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetColor(t: TypeDegatValues) {
    if(t != undefined && t != null && t == TypeDegatValues.PersonneConnue) {
      return { 'color': 'red' };
    }
  }

  GetDegatsType(t: TypeDegatValues) {
    if (t === undefined || t == null) {
      return '';
    } else {
      return this.translateService.instant('Entretien.Interventions.TypeDegats.' + TypeDegatValues[t]);
    }
  } 
}
